export const USD_REGIONS = ['US', 'CA', 'MX', 'UM', 'PR', 'VI', 'GU', 'MP', 'AS'];

export const isUsdRegion = (countryCode: string) => USD_REGIONS.includes(countryCode);
